import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {Source} from "../../../model/mapping/source";
import {MappingSourceService} from "../../../services/mapping/mapping-source.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-source',
  templateUrl: './source.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class SourceComponent extends CrudBaseComponent<Source> {

  //fields
  sourceTypes: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              crudService: MappingSourceService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = crudService;
    this.newRecord = new Source();
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.originCode = undefined;
      this.formRecord.code = undefined;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'code',
        width: 130
      },
      {
        field: 'description',
        width: 130
      },
      {
        field: 'type',
        width: 130
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'code',
            required: true,
            column: 6,
            type: TYPE.TEXT
          },
          {
            field: 'description',
            column: 6,
            type: TYPE.TEXT
          },
          {
            field: 'type',
            required: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.sourceTypes,
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.sourceTypes = [];
    for (let key in Source.SourceType) {
      this.sourceTypes.push(new FieldRecord(key, key.toLowerCase()))
    }
  }

  onFormShow() {
  }
}
